// src/Modules/Services/serviceTypes.ts

// 1. Enum for Price Types (Backend Values)
export enum ServicePriceType {
  DAY_PERSON = "per_day_per_person",
  PER_QTY = "per_qty",
  DAY = "per_day",
  BRACING = "bracing",
  CUSTOM = "custom",
}

// 2. Enum for Plant Hire Categories (Backend Values)
export enum PlantHireCategory {
  SCISSOR_LIFT = "scissor_lift",
  FLT = "fork_lift_truck",
  REACH_TRUCK = "reach_truck",
}

// --- LABELS MAPPING ---
// This acts as a dictionary to translate "computer speak" to "human speak"
export const PriceTypeLabels: Record<ServicePriceType, string> = {
  [ServicePriceType.DAY_PERSON]: "Day / Person",
  [ServicePriceType.PER_QTY]: "Qty",
  [ServicePriceType.DAY]: "Day",
  [ServicePriceType.BRACING]: "Bracing",
  [ServicePriceType.CUSTOM]: "Custom",
};

const PlantCategoryLabels: Record<PlantHireCategory, string> = {
  [PlantHireCategory.SCISSOR_LIFT]: "Scissor Lift",
  [PlantHireCategory.FLT]: "F.L.T", // Keeping abbreviation as per previous UI
  [PlantHireCategory.REACH_TRUCK]: "Reach Truck",
};

// 3. Helper to list options for Dropdowns
export const PriceTypeOptions = Object.values(ServicePriceType).map(
  (value) => ({
    label: PriceTypeLabels[value], // Look up the pretty name
    value: value, // Send the snake_case to backend
  }),
);

export const PlantCategoryOptions = Object.values(PlantHireCategory).map(
  (value) => ({
    label: PlantCategoryLabels[value], // Look up the pretty name
    value: value, // Send the snake_case to backend
  }),
);
